import { createListenerMiddleware } from '@reduxjs/toolkit';

import { installationSlice } from '../reducer';

const listenerMiddleware = createListenerMiddleware();

/**
 * Слушатель, срабатывающий на изменение текущей страницы, при котором
 * происходит добавление новой страницы в список посещенных пользователем
 */
listenerMiddleware.startListening({
  actionCreator: installationSlice.actions.setPage,
  effect: (action, listenerApi) => {
    if (action.payload) {
      listenerApi.dispatch(installationSlice.actions.addVisitedPage(action.payload));
    }
  },
});

export default listenerMiddleware.middleware;
